import React from "react"
import { Outlet } from "react-router-dom"
import Layout from "@/components/layout"
import { SettingsSidebar } from "@/components/settings/sidebar"

const SettingsWrapper: React.FC = () => {
  return (
    <Layout title="Settings" padding={false} className="flex flex-row gap-0 m-0 p-0 bg-gray-200 min-h-[100vh]">
      <SettingsSidebar />
      <div className="flex-1 p-4 flex flex-col min-h-0" data-testid="settings-layout-content">
        <Outlet />
      </div>
    </Layout>
  )
}

export default SettingsWrapper
